var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalCardSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 17.5H5.83341C2.50008 17.5 1.66675 16.6667 1.66675 13.3333V6.66667C1.66675 3.33333 2.50008 2.5 5.83341 2.5H14.1667C17.5001 2.5 18.3334 3.33333 18.3334 6.66667V13.3333C18.3334 16.6667 17.5001 17.5 14.1667 17.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 6.66675H15.8334",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10H15.8333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 13.3333H15.8334",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08328 9.40827C7.91631 9.40827 8.59162 8.73296 8.59162 7.89993C8.59162 7.0669 7.91631 6.3916 7.08328 6.3916C6.25026 6.3916 5.57495 7.0669 5.57495 7.89993C5.57495 8.73296 6.25026 9.40827 7.08328 9.40827Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 13.6082C9.88341 12.3999 8.92508 11.4499 7.71675 11.3416C7.30008 11.2999 6.87508 11.2999 6.45008 11.3416C5.24175 11.4582 4.28341 12.3999 4.16675 13.6082",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalCardSolid);
export default __webpack_public_path__ + "static/media/personal-card-solid.983614328bf013c5f7affa992b2ef50c.svg";
export { ForwardRef as ReactComponent };